import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { serializeClasses } from 'utilities/css';
import { Box } from './box';

const AddressContainer = styled(Box)`
  white-space: pre;
  flex-direction: column;
  &.inline {
    flex-direction: row;
    .name-text::after {
      content: '• '
    }
    .address-text::after {
      content: ', '
    }
  }
  .address-text::after {
      content: ' '
  }
  &.info {
    color: ${({ theme }) => theme.colors.text03};
  }
`;

export const Address = ({
  inline,
  className,
  address,
  city,
  stateCode,
  zip,
  showName,
  name,
  ...rest
}) => {
  const classes = serializeClasses([inline && 'inline', className]);
  return (
    <AddressContainer {...rest} className={classes}>
      {showName && (
        <div className="name-text">{`${name} `}</div>
      )}
      <div className="address-text">{address}</div>
      <div>{`${city}, ${stateCode} ${zip}`}</div>
    </AddressContainer>
  );
};

Address.propTypes = {
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  stateCode: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  className: PropTypes.string,
  showName: PropTypes.bool,
  name: PropTypes.string
};

Address.defaultProps = {
  inline: false,
  className: undefined,
  showName: false,
  name: ''
};
